module.exports = "Once *{{customerName}}* logs in Follo, they will have access to their metrics."


//////////////////
// WEBPACK FOOTER
// ./src/statsradio/modules/campaigns/i18n/markdown/en/custumerName.md
// module id = ./src/statsradio/modules/campaigns/i18n/markdown/en/custumerName.md
// module chunks = 18